import { PLATFORM_HOST_SLUG, PLATFORM_PATH_PREFIX } from '@/lib/platform/routing'

/**
 * Where the login page sends a freshly signed-in user. Pure so it is testable;
 * the page passes window.location.hostname.
 *
 * Production hosts live under kehillahq.com (the login page has always
 * hardcoded this domain for the tenant redirect). Localhost and Vercel
 * previews are path-routed, mirroring src/proxy.ts.
 */
const PROD_ROOT = 'kehillahq.com'

export function postLoginDestination(
    user: { role?: string | null; tenantSlug?: string | null },
    hostname: string,
    callbackUrl: string
): string {
    const onProdDomain = hostname === PROD_ROOT || hostname.endsWith(`.${PROD_ROOT}`)

    if (user.role === 'SUPER_ADMIN') {
        return onProdDomain ? `https://${PLATFORM_HOST_SLUG}.${PROD_ROOT}` : PLATFORM_PATH_PREFIX
    }
    if (user.tenantSlug) {
        return onProdDomain ? `https://${user.tenantSlug}.${PROD_ROOT}` : `/${user.tenantSlug}`
    }
    return callbackUrl
}
